import React from 'react';
import { Text, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { ColorCard as ColorCardNPM } from '@rotaryintl/component-color-card-grid';
import { createLink } from '../../utilities/link-helpers';

const ColorCard = ({ fields: { Title, Subtitle, Description, BackgroundColor, Link, LinkText } = {} }) => {
  return (
    <ColorCardNPM
      title={<Text field={Title} />}
      subTitle={<Text field={Subtitle} />}
      description={<RichText field={Description} />}
      backgroundColor={BackgroundColor?.fields?.Color?.value}
      link={createLink(Link, LinkText)}
    />
  );
};

export default withSitecoreContext()(ColorCard);
